import classNames from 'classnames';
import * as React from 'react';
import DV         from 'ts-data-validator';

import { staticPageConstants } from '../../../../common/constants/staticPageConstants';

const ButtonTabsNav = function(props) {
  const {
          active,
          changeState,
          changeTab,
          label,
          nav,
          open,
          style,
        } = props;

  const optionsRef  = React.useRef(null);
  const selectedRef = React.useRef(null);

  const handleChangeState  = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    changeState(!open);
  }, [changeState, open]);
  const handleChangeTab    = React.useCallback((event, index) => {
    if (active !== index) {
      changeState(event);
      changeTab(index);
    }
  }, [active, changeState, changeTab]);
  const handleClickOutside = React.useCallback((event) => {
    if (
      open &&
      (optionsRef.current && !optionsRef.current.contains(event.target)) ||
      (selectedRef.current && !selectedRef.current.contains(event.target))
    ) {
      handleChangeState(event);
    }
  }, [handleChangeState, open]);

  React.useEffect(() => {
    if (open) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside, open]);

  return (
    <div className={classNames('tabs-select', { open })}>
      {DV.isNotEmptyString(label) && (
        <div className={'title'}>{label}</div>
      )}
      <div
        ref={selectedRef}
        className={'selected'}
        onClick={handleChangeState}
        title={style === staticPageConstants.COMPONENTS.BUTTON_TABS.SETTINGS.STYLE.SELECT ? Object.values(nav)[active] : null}
      >
        {Object.values(nav)[active]}
        <span className={'ic-arrow-bottom'} />
      </div>
      <div className={'body'}>
        <ul ref={optionsRef} className={'tabs basic-tabs'}>
          {Object.values(nav)
            .map((tab, tabIndex) => (
              <li
                key={tabIndex}
                className={classNames({ 'active': active === tabIndex })}
                onClick={(event) => handleChangeTab(event, tabIndex)}
                title={style === staticPageConstants.COMPONENTS.BUTTON_TABS.SETTINGS.STYLE.SELECT ? tab : null}
              >{tab}</li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default ButtonTabsNav;